import type { CustomerType } from "../../@types/sharedSchema";

export const mappedCustomerTypes: Record<CustomerType, string> = {
  מוכר: "seller",
  קונה: "buyer",
  שוכר: "tenant",
  משכיר: "landlord",
  מתווך: "realtor",
  שמאי: "appraiser",
  'עו"ד': "attorney"
} as const;
